import { useIntl } from "react-intl";

import { messages } from "../messages";

export const MyDesignProjectSvg = () => {
    const { formatMessage } = useIntl();
    const label = formatMessage(messages.myDesignProject);

    return (
        <svg
            width="570"
            height="640"
            viewBox="0 0 570 640"
            fill="none"
            role="img"
            aria-label={label}
        >
            <g clipPath="url(#clip0_3262_221211)">
                <rect width="570" height="640" fill="white" />
                <mask
                    id="mask0_3262_221211"
                    style={{ maskType: "alpha" as const }}
                    maskUnits="userSpaceOnUse"
                    x="5"
                    y="-156"
                    width="856"
                    height="1397"
                >
                    <path
                        d="M645.316 693.914C602.354 640.667 591.907 588.286 607.005 528.973C623.432 464.439 662.453 420.944 720.659 397.928L860.712 -152.277C413.924 -185.4 123.663 13.4133 31.7092 374.658C-53.9323 711.104 58.8342 982.705 506.186 1240.49L645.353 693.769L645.316 693.914Z"
                        fill="#BF63F3"
                    />
                </mask>
                <g mask="url(#mask0_3262_221211)">
                    <g clipPath="url(#clip1_3262_221211)">
                        <rect
                            width="882.133"
                            height="911.409"
                            transform="translate(840.056 -20.8359) rotate(104.62)"
                            fill="#1868DB"
                        />
                        <path
                            d="M141.345 -1058.3L-147.327 48.3345L874.045 211.731L2096.08 -548.389L141.345 -1058.3Z"
                            fill="#FCA700"
                        />
                        <path
                            d="M-490.224 -275.724C-401.55 -198.067 -341.048 -102.666 -312.22 9.70159C-283.392 122.07 -289.813 242.151 -333.784 353.951L1023.48 44.8387C1030.89 -63.1968 1021.12 -172.668 992.825 -282.956C964.531 -393.243 922.183 -492.778 865.662 -584.366L-490.469 -275.511L-490.224 -275.724Z"
                            fill="#BF63F3"
                        />
                        <path
                            d="M139.667 270.84C110.361 80.2241 22.2733 -82.4927 -145.488 -131.946C-145.488 -131.946 -146.378 -132.08 -146.781 -132.278C-159.257 -135.907 -172.024 -138.998 -185.286 -141.274C-185.408 -141.258 -185.529 -141.243 -185.651 -141.227C-199.054 -143.61 -212.97 -145.301 -227.28 -146.316C-230.661 -146.502 -234.247 -146.41 -237.628 -146.596C-249.128 -147.101 -260.628 -147.606 -272.726 -147.158C-288.775 -146.572 -305.218 -145.309 -322.258 -143.093C-353.784 -138.993 -382.769 -132.098 -409.243 -123.404C-444.46 -111.822 -475.217 -97.0697 -501.59 -81.2618C-508.179 -77.2792 -514.524 -73.3282 -520.588 -69.1637C-544.765 -48.765 -577.708 -18.3493 -623.373 35.1018C-653.267 69.9976 -688.686 114.99 -730.722 173.47C-661.683 247.014 -622.255 358.918 -573.522 466.737C-534.981 551.874 -490.656 634.258 -421.201 692.745C-357.584 746.363 -267.28 770.88 -163.453 757.378C96.4195 723.584 178.105 520.035 139.827 271.07L139.667 270.84Z"
                            fill="#FCA700"
                        />
                        <mask
                            id="mask1_3262_221211"
                            style={{ maskType: "alpha" as const }}
                            maskUnits="userSpaceOnUse"
                            x="-491"
                            y="-585"
                            width="1517"
                            height="939"
                        >
                            <path
                                d="M-490.224 -275.721C-401.55 -198.063 -341.047 -102.662 -312.219 9.70561C-283.391 122.074 -289.812 242.155 -333.784 353.955L1023.48 44.8426C1030.89 -63.1929 1021.12 -172.665 992.825 -282.952C964.531 -393.239 922.184 -492.774 865.663 -584.362L-490.469 -275.507L-490.224 -275.721Z"
                                fill="#BF63F3"
                            />
                        </mask>
                        <g mask="url(#mask1_3262_221211)">
                            <path
                                d="M139.669 270.844C110.362 80.228 22.275 -82.4888 -145.487 -131.942C-145.487 -131.942 -146.376 -132.076 -146.779 -132.274C-159.255 -135.903 -172.022 -138.994 -185.284 -141.27C-185.406 -141.255 -185.528 -141.239 -185.649 -141.223C-199.052 -143.606 -212.969 -145.297 -227.278 -146.312C-230.659 -146.498 -234.245 -146.407 -237.626 -146.592C-249.126 -147.097 -260.626 -147.602 -272.724 -147.154C-288.774 -146.568 -305.216 -145.305 -322.257 -143.089C-353.782 -138.989 -382.767 -132.094 -409.241 -123.4C-444.458 -111.818 -475.215 -97.0658 -501.588 -81.2579C-508.177 -77.2753 -514.522 -73.3242 -520.586 -69.1598C-544.764 -48.7611 -577.706 -18.3453 -623.371 35.1057C-653.265 70.0015 -688.684 114.993 -730.72 173.474C-661.682 247.018 -622.253 358.922 -573.521 466.741C-534.98 551.878 -490.654 634.262 -421.199 692.748C-357.583 746.367 -267.278 770.884 -163.451 757.382C96.4213 723.588 178.106 520.039 139.829 271.073L139.669 270.844Z"
                                fill="#AE2A19"
                            />
                        </g>
                        <path
                            d="M1184.12 950.475L1260.15 -118.323C1260.15 -118.323 751.382 -138.94 372.579 -481.075C361.97 -450.526 352.246 -419.358 344.387 -387.327C199.851 201.727 575.855 800.633 1184.31 950.523L1184.12 950.475Z"
                            fill="#82B536"
                        />
                        <mask
                            id="mask2_3262_221211"
                            style={{ maskType: "alpha" as const }}
                            maskUnits="userSpaceOnUse"
                            x="-491"
                            y="-585"
                            width="1517"
                            height="939"
                        >
                            <path
                                d="M-490.224 -275.721C-401.55 -198.063 -341.047 -102.662 -312.219 9.70561C-283.391 122.074 -289.812 242.155 -333.784 353.955L1023.48 44.8426C1030.89 -63.1929 1021.12 -172.665 992.825 -282.952C964.531 -393.239 922.184 -492.774 865.663 -584.362L-490.469 -275.507L-490.224 -275.721Z"
                                fill="#BF63F3"
                            />
                        </mask>
                        <g mask="url(#mask2_3262_221211)">
                            <path
                                d="M1184.11 950.476L1260.14 -118.322C1260.14 -118.322 751.374 -138.939 372.572 -481.074C361.962 -450.525 352.238 -419.357 344.379 -387.326C199.844 201.728 575.848 800.634 1184.31 950.524L1184.11 950.476Z"
                                fill="#1868DB"
                            />
                        </g>
                    </g>
                </g>
                <path
                    d="M50 126C50 119.373 55.3726 114 62 114H570V640H50V126Z"
                    fill="#44546F"
                    fillOpacity="0.12"
                />
                <g clipPath="url(#clip2_3262_221211)">
                    <mask id="path-11-inside-1_3262_221211" fill="white">
                        <path d="M68 100C68 93.3726 73.3726 88 80 88H570V640H68V100Z" />
                    </mask>
                    <path
                        d="M68 100C68 93.3726 73.3726 88 80 88H570V640H68V100Z"
                        fill="white"
                    />
                    <g clipPath="url(#clip3_3262_221211)">
                        <g clipPath="url(#clip4_3262_221211)">
                            <path
                                d="M132 112H100V144H132V112Z"
                                fill="#1868DB"
                            />
                            <path
                                d="M113.064 138.304C108.464 134.072 104.36 132.496 100 132.224V144H117.168C116.112 141.84 114.768 139.872 113.064 138.304Z"
                                fill="#FCA700"
                            />
                            <path
                                d="M106.8 140.92C106.896 140.736 106.352 140.024 106.16 140.056C105.88 140.096 105.632 140.184 105.352 140.36C105.064 140.592 105.072 140.8 104.84 140.912C104.464 141.136 103.696 141.216 103.52 141.216C103.496 141.216 103.472 141.224 103.448 141.24C103.296 141.344 102.592 141.768 101.896 141.872C101.424 142 101.12 142.048 100.968 142.08C100.6 142.152 100.336 142.272 100.072 142.472C99.928 142.584 99.992 143.352 100.168 143.432C100.488 143.568 100.808 143.624 101.224 143.56C101.384 143.536 101.76 143.68 102.248 143.6C102.328 143.584 102.4 143.552 102.464 143.496C103.04 143.048 103.872 142.808 103.872 142.808C103.872 142.808 104.176 142.688 104.536 142.528C104.888 142.36 105.304 142.152 105.536 142.008C105.896 141.8 106.056 141.688 106.16 141.624C106.464 141.416 106.664 141.192 106.8 140.928V140.92Z"
                                fill="#101214"
                            />
                            <path
                                d="M101.424 116.376C100.552 116.56 100.2 116.944 100.272 117.176C100.344 117.416 100.8 117.528 101.592 117.448C102.728 117.344 103.896 117.384 105.112 117.664C106.312 117.944 107.592 118.448 108.528 119.448C109.04 120 109.312 120.584 109.44 121.088C109.568 121.592 109.576 122.032 109.496 122.408C109.344 123.12 108.84 123.824 107.904 124.08C107.512 124.184 107.08 124.152 106.688 123.944C106.288 123.736 105.936 123.344 105.728 122.872C105.28 121.936 105.536 120.728 106.128 119.8C106.712 118.856 107.56 118.168 108.304 117.744C109.064 117.32 109.728 117.128 110.096 117.032C110.32 116.984 110.536 116.92 110.76 116.88C111.152 116.792 111.904 116.656 112.896 116.72C113.88 116.792 115.128 117.096 116.36 117.792C117.592 118.48 118.816 119.552 119.736 120.88C120.672 122.208 121.328 123.808 121.8 125.408C122.48 127.664 122.848 129.6 123.248 131.128C123.632 132.656 124 133.784 124.296 134.544C125.648 138.152 127.944 140.544 130.704 141.512C131.472 141.768 131.92 141.616 131.96 141.416C132.008 141.192 131.696 140.928 131.064 140.624C128.768 139.456 126.952 137.352 125.696 134.016C125.448 133.368 125.152 132.328 124.856 130.92C124.544 129.52 124.256 127.736 123.696 125.64C123.512 124.96 123.28 124.28 123 123.624C122.408 122.208 121.616 120.712 120.568 119.432C119.528 118.152 118.272 117.12 117.032 116.44C115.792 115.752 114.6 115.408 113.744 115.256C113.312 115.184 112.96 115.152 112.728 115.144C112.488 115.12 112.36 115.128 112.36 115.128C112.36 115.128 112.168 115.12 111.816 115.136C111.472 115.152 110.968 115.192 110.36 115.32C109.16 115.568 107.496 116.184 106.12 117.52C105.448 118.184 104.84 119 104.472 119.968C104.104 120.92 103.992 122.056 104.36 123.072C104.712 124.064 105.456 124.896 106.4 125.256C107.36 125.632 108.336 125.4 108.976 125.056C109.96 124.52 110.56 123.68 110.8 122.856C111.04 122.04 110.976 121.312 110.848 120.736C110.56 119.568 110.04 118.904 109.64 118.448C108.352 117.088 106.776 116.576 105.4 116.32C104 116.072 102.672 116.136 101.448 116.392L101.424 116.376Z"
                                fill="#101214"
                            />
                            <path
                                d="M106.904 140.336L114.848 134.976L109.208 131.032L106.904 140.336Z"
                                fill="white"
                            />
                            <path
                                d="M107.728 137.008L106.904 140.336L109.744 138.416L107.728 137.008Z"
                                fill="#101214"
                            />
                            <path
                                d="M122.56 112L109.208 131.032L114.848 134.976L130.96 112H122.56Z"
                                fill="#FFC716"
                            />
                        </g>
                    </g>
                    <path
                        d="M149.78 128.14L148.28 123.04V134H145.36V120.86H150.62L152.6 126.3L153.62 130.32L154.68 126.3L156.64 120.86H161.52V134H158.44V123.18L157.08 128.14L154.94 134H151.9L149.78 128.14ZM165.194 138.02C163.974 138.02 163.454 137.94 162.914 137.74V135.14C163.574 135.32 164.194 135.4 164.894 135.4C166.334 135.4 166.874 134.66 167.374 133.18H165.514L162.594 123.78H165.534L167.834 131.66L170.134 123.78H173.094L169.954 133.66C169.034 136.56 167.774 138.02 165.194 138.02ZM183.042 123.68H180.942V131.18H183.142C185.382 131.18 186.522 129.96 186.522 127.46C186.522 124.92 185.442 123.68 183.042 123.68ZM177.722 134V120.86H183.122C187.542 120.86 189.682 123.52 189.682 127.46C189.682 131.44 187.522 134 183.122 134H177.722ZM195.71 125.78C194.43 125.78 193.79 126.64 193.65 128.14H197.65C197.53 126.56 196.93 125.78 195.71 125.78ZM199.95 133.6C199.03 133.98 197.71 134.2 196.49 134.2C192.51 134.2 190.75 132.26 190.75 128.98C190.75 125.82 192.49 123.56 195.79 123.56C199.07 123.56 200.39 125.8 200.39 128.98V129.76H193.69C193.93 131.08 194.79 131.68 196.57 131.68C197.77 131.68 198.95 131.48 199.95 131.16V133.6ZM209.574 130.98C209.574 132.94 208.394 134.22 205.454 134.22C203.834 134.22 202.474 133.84 201.654 133.4V130.86C202.574 131.32 204.134 131.84 205.474 131.84C206.374 131.84 206.834 131.5 206.834 130.98C206.834 130.48 206.414 130.2 205.114 129.9C202.414 129.4 201.514 128.28 201.514 126.68C201.514 124.7 202.994 123.56 205.534 123.56C206.974 123.56 208.314 123.88 209.134 124.32V126.84C207.814 126.28 206.614 125.92 205.494 125.92C204.614 125.92 204.174 126.22 204.174 126.72C204.174 127.18 204.514 127.46 205.934 127.78C208.694 128.32 209.574 129.34 209.574 130.98ZM210.615 121C210.615 119.9 211.395 119.26 212.495 119.26C213.595 119.26 214.375 119.9 214.375 121C214.375 122.1 213.595 122.72 212.495 122.72C211.395 122.72 210.615 122.1 210.615 121ZM210.995 134V123.78H213.975V134H210.995ZM222.238 132.9V131.8C221.618 133.16 220.498 133.82 219.098 133.82C216.618 133.82 215.438 131.64 215.438 128.7C215.438 125.9 216.638 123.58 219.278 123.58C220.678 123.58 221.678 124.34 222.238 125.56V123.78H225.198V132.78C225.198 135.92 223.678 138.02 219.678 138.02C218.178 138.02 216.938 137.82 215.858 137.48V134.78C216.998 135.22 218.158 135.42 219.418 135.42C221.518 135.42 222.238 134.36 222.238 132.9ZM218.358 128.7C218.358 130.44 219.018 131.32 220.258 131.32C221.358 131.32 222.238 130.6 222.238 128.94V128.4C222.238 126.82 221.418 126.12 220.378 126.12C219.038 126.12 218.358 127.04 218.358 128.7ZM236.448 127.88V134H233.468V127.88C233.468 126.64 233.008 126.1 231.928 126.1C230.828 126.1 230.088 126.82 230.088 128.32V134H227.108V123.78H230.088V125.54C230.688 124.28 231.728 123.56 233.148 123.56C235.388 123.56 236.448 125.14 236.448 127.88ZM252.402 125.64C252.402 128.68 250.742 130.38 247.362 130.38H245.162V134H241.962V120.86H247.362C250.742 120.86 252.402 122.7 252.402 125.64ZM247.082 127.76C248.762 127.82 249.402 126.98 249.402 125.68C249.402 124.46 248.762 123.64 247.082 123.64H245.162V127.76H247.082ZM256.514 128.64V134H253.554V123.78H256.514V125.74C257.074 124.36 257.974 123.54 259.574 123.64V126.66C257.494 126.5 256.514 127 256.514 128.64ZM265.165 134.24C261.965 134.24 260.105 132.02 260.105 128.88C260.105 125.72 261.965 123.56 265.165 123.56C268.345 123.56 270.185 125.72 270.185 128.88C270.185 132.02 268.345 134.24 265.165 134.24ZM265.165 126.16C263.665 126.16 263.005 127.34 263.005 128.88C263.005 130.42 263.665 131.64 265.165 131.64C266.645 131.64 267.285 130.42 267.285 128.88C267.285 127.34 266.645 126.16 265.165 126.16ZM270.22 137.88V135.38C270.46 135.4 270.56 135.4 270.78 135.4C271.3 135.4 271.74 135.16 271.74 134.4V123.78H274.72V134.66C274.72 137 273.34 137.98 271.5 137.98C270.86 137.98 270.52 137.94 270.22 137.88ZM271.34 121C271.34 119.9 272.12 119.26 273.22 119.26C274.32 119.26 275.1 119.9 275.1 121C275.1 122.1 274.32 122.72 273.22 122.72C272.12 122.72 271.34 122.1 271.34 121ZM281.14 125.78C279.86 125.78 279.22 126.64 279.08 128.14H283.08C282.96 126.56 282.36 125.78 281.14 125.78ZM285.38 133.6C284.46 133.98 283.14 134.2 281.92 134.2C277.94 134.2 276.18 132.26 276.18 128.98C276.18 125.82 277.92 123.56 281.22 123.56C284.5 123.56 285.82 125.8 285.82 128.98V129.76H279.12C279.36 131.08 280.22 131.68 282 131.68C283.2 131.68 284.38 131.48 285.38 131.16V133.6ZM294.883 131.08V133.64C294.223 134.02 293.303 134.22 292.283 134.22C288.583 134.22 286.863 132 286.863 128.88C286.863 125.78 288.583 123.56 292.143 123.56C293.243 123.56 293.983 123.74 294.823 124.14V126.74C294.183 126.44 293.503 126.26 292.563 126.26C290.583 126.26 289.783 127.46 289.783 128.88C289.783 130.3 290.643 131.46 292.623 131.46C293.683 131.46 294.283 131.3 294.883 131.08ZM299.827 130.26C299.827 131 300.227 131.42 301.027 131.42C301.367 131.42 301.667 131.36 301.927 131.3V133.92C301.487 134.04 301.007 134.12 300.247 134.12C297.827 134.12 296.867 132.7 296.867 130.6V126.28H295.647V123.78H296.867V121.66H299.827V123.78H301.927V126.28H299.827V130.26Z"
                        fill="#292A2E"
                    />
                    <mask id="path-22-inside-2_3262_221211" fill="white">
                        <path d="M100 174C100 170.686 102.686 168 106 168H274C277.314 168 280 170.686 280 174V194C280 197.314 277.314 200 274 200H106C102.686 200 100 197.314 100 194V174Z" />
                    </mask>
                    <path
                        d="M100 174C100 170.686 102.686 168 106 168H274C277.314 168 280 170.686 280 174V194C280 197.314 277.314 200 274 200H106C102.686 200 100 197.314 100 194V174Z"
                        fill="white"
                    />
                    <path
                        d="M106 168V169H274V168V167H106V168ZM280 174H279V194H280H281V174H280ZM274 200V199H106V200V201H274V200ZM100 194H101V174H100H99V194H100ZM106 200V199C103.239 199 101 196.761 101 194H100H99C99 197.866 102.134 201 106 201V200ZM280 194H279C279 196.761 276.761 199 274 199V200V201C277.866 201 281 197.866 281 194H280ZM274 168V169C276.761 169 279 171.239 279 174H280H281C281 170.134 277.866 167 274 167V168ZM106 168V167C102.134 167 99 170.134 99 174H100H101C101 171.239 103.239 169 106 169V168Z"
                        fill="#0B1228"
                        fillOpacity="0.14"
                        mask="url(#path-22-inside-2_3262_221211)"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M259 178.5C256.515 178.5 254.5 180.515 254.5 183C254.5 185.485 256.515 187.5 259 187.5C260.243 187.5 261.367 186.997 262.182 186.182C262.997 185.367 263.5 184.243 263.5 183C263.5 180.515 261.485 178.5 259 178.5ZM253 183C253 179.686 255.686 177 259 177C262.314 177 265 179.686 265 183C265 184.386 264.529 185.663 263.74 186.679L267.03 189.97L265.97 191.03L262.679 187.74C261.663 188.529 260.386 189 259 189C255.686 189 253 186.314 253 183Z"
                        fill="#505258"
                    />
                    <rect
                        x="292"
                        y="168"
                        width="32"
                        height="32"
                        rx="16"
                        fill="#6A9A23"
                    />
                    <path
                        d="M302.869 188L299.787 179.27H301.65L303.115 183.635C303.271 184.131 303.434 184.688 303.602 185.305C303.773 185.918 303.957 186.602 304.152 187.355H303.795C303.982 186.59 304.158 185.902 304.322 185.293C304.486 184.684 304.643 184.131 304.791 183.635L306.215 179.27H308.066L305.043 188H302.869ZM312.326 188.129C311.639 188.129 311.041 188.023 310.533 187.812C310.025 187.598 309.629 187.285 309.344 186.875C309.059 186.461 308.906 185.955 308.887 185.357H310.533C310.557 185.658 310.646 185.908 310.803 186.107C310.963 186.307 311.174 186.457 311.436 186.559C311.697 186.656 311.99 186.705 312.314 186.705C312.643 186.705 312.932 186.656 313.182 186.559C313.432 186.457 313.627 186.318 313.768 186.143C313.908 185.963 313.979 185.756 313.979 185.521C313.979 185.307 313.916 185.129 313.791 184.988C313.666 184.848 313.488 184.729 313.258 184.631C313.031 184.529 312.758 184.441 312.438 184.367L311.465 184.115C310.73 183.932 310.156 183.648 309.742 183.266C309.328 182.883 309.121 182.379 309.121 181.754C309.121 181.234 309.262 180.779 309.543 180.389C309.824 179.998 310.209 179.695 310.697 179.48C311.186 179.262 311.74 179.152 312.361 179.152C312.994 179.152 313.547 179.262 314.02 179.48C314.496 179.699 314.867 180.002 315.133 180.389C315.402 180.771 315.541 181.213 315.549 181.713H313.92C313.885 181.35 313.727 181.07 313.445 180.875C313.168 180.676 312.799 180.576 312.338 180.576C312.025 180.576 311.756 180.623 311.529 180.717C311.307 180.807 311.135 180.934 311.014 181.098C310.896 181.258 310.838 181.441 310.838 181.648C310.838 181.879 310.906 182.068 311.043 182.217C311.184 182.365 311.363 182.484 311.582 182.574C311.805 182.664 312.035 182.738 312.273 182.797L313.076 182.996C313.424 183.078 313.752 183.188 314.061 183.324C314.373 183.461 314.65 183.631 314.893 183.834C315.135 184.033 315.324 184.273 315.461 184.555C315.598 184.832 315.666 185.158 315.666 185.533C315.666 186.053 315.533 186.508 315.268 186.898C315.006 187.289 314.625 187.592 314.125 187.807C313.629 188.021 313.029 188.129 312.326 188.129Z"
                        fill="white"
                    />
                    <g clipPath="url(#clip5_3262_221211)">
                        <rect
                            x="100"
                            y="216"
                            width="1100"
                            height="660"
                            rx="8"
                            fill="white"
                        />
                        <mask id="path-29-inside-3_3262_221211" fill="white">
                            <path d="M100 216H1200V264H100V216Z" />
                        </mask>
                        <path d="M100 216H1200V264H100V216Z" fill="#F8F8F8" />
                        <path
                            d="M1200 264V263H100V264V265H1200V264Z"
                            fill="#0B1228"
                            fillOpacity="0.14"
                            mask="url(#path-29-inside-3_3262_221211)"
                        />
                        <rect
                            x="100"
                            y="305"
                            width="1100"
                            height="39"
                            fill="#F8F8F8"
                        />
                        <rect
                            x="100"
                            y="385"
                            width="1100"
                            height="39"
                            fill="#F8F8F8"
                        />
                        <mask id="path-33-inside-4_3262_221211" fill="white">
                            <path d="M100 465H1200V505H100V465Z" />
                        </mask>
                        <path d="M100 465H1200V505H100V465Z" fill="#F8F8F8" />
                        <path
                            d="M1200 505V504H100V505V506H1200V505Z"
                            fill="#0B1228"
                            fillOpacity="0.14"
                            mask="url(#path-33-inside-4_3262_221211)"
                        />
                        <line
                            x1="232.5"
                            y1="216"
                            x2="232.5"
                            y2="876"
                            stroke="#0B1228"
                            strokeOpacity="0.14"
                        />
                        <g opacity="0.8">
                            <rect
                                x="116"
                                y="237"
                                width="100"
                                height="6"
                                rx="3"
                                fill="#080F21"
                                fillOpacity="0.28"
                            />
                        </g>
                        <rect
                            x="116"
                            y="281"
                            width="80"
                            height="6"
                            rx="3"
                            fill="#091E42"
                            fillOpacity="0.13"
                        />
                        <rect
                            x="116"
                            y="361"
                            width="80"
                            height="6"
                            rx="3"
                            fill="#091E42"
                            fillOpacity="0.13"
                        />
                        <rect
                            x="116"
                            y="321"
                            width="80"
                            height="6"
                            rx="3"
                            fill="#091E42"
                            fillOpacity="0.13"
                        />
                        <rect
                            x="116"
                            y="401"
                            width="80"
                            height="6"
                            rx="3"
                            fill="#091E42"
                            fillOpacity="0.13"
                        />
                        <rect
                            x="116"
                            y="441"
                            width="80"
                            height="6"
                            rx="3"
                            fill="#091E42"
                            fillOpacity="0.13"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M119.25 485.75V492H120.75V485.75H127V484.25H120.75V478H119.25V484.25H113V485.75H119.25Z"
                            fill="#6B6E76"
                        />
                        <rect
                            x="136"
                            y="483"
                            width="64"
                            height="4"
                            rx="2"
                            fill="#091E42"
                            fillOpacity="0.13"
                        />
                        <line
                            x1="412.5"
                            y1="216"
                            x2="412.5"
                            y2="876"
                            stroke="#0B1228"
                            strokeOpacity="0.14"
                        />
                        <g opacity="0.8">
                            <rect
                                x="272"
                                y="237"
                                width="96"
                                height="6"
                                rx="3"
                                fill="#080F21"
                                fillOpacity="0.28"
                            />
                        </g>
                        <g opacity="0.8">
                            <rect
                                x="456"
                                y="237"
                                width="96"
                                height="6"
                                rx="3"
                                fill="#080F21"
                                fillOpacity="0.28"
                            />
                        </g>
                        <rect
                            x="240"
                            y="272"
                            width="336"
                            height="24"
                            rx="4"
                            fill="#DDDEE1"
                        />
                        <rect
                            width="4"
                            height="4"
                            rx="2"
                            transform="matrix(1 0 0 -1 244 276)"
                            fill="#DDDEE1"
                        />
                        <rect
                            width="4"
                            height="4"
                            rx="2"
                            transform="matrix(1 0 0 -1 568 296)"
                            fill="#DDDEE1"
                        />
                        <rect
                            x="336"
                            y="313"
                            width="288"
                            height="24"
                            rx="4"
                            fill="#DDDEE1"
                        />
                        <rect
                            width="4"
                            height="4"
                            rx="2"
                            transform="matrix(1 0 0 -1 340 317)"
                            fill="#DDDEE1"
                        />
                        <rect
                            x="496"
                            y="393"
                            width="288"
                            height="24"
                            rx="4"
                            fill="#DDDEE1"
                        />
                        <rect
                            width="4"
                            height="4"
                            rx="2"
                            transform="matrix(1 0 0 -1 500 397)"
                            fill="#DDDEE1"
                        />
                        <rect
                            x="392"
                            y="432"
                            width="288"
                            height="24"
                            rx="4"
                            fill="#DDDEE1"
                        />
                        <rect
                            width="4"
                            height="4"
                            rx="2"
                            transform="matrix(1 0 0 -1 396 436)"
                            fill="#DDDEE1"
                        />
                        <rect
                            x="424"
                            y="353"
                            width="288"
                            height="24"
                            rx="4"
                            fill="#DDDEE1"
                        />
                        <rect
                            width="4"
                            height="4"
                            rx="2"
                            transform="matrix(1 0 0 -1 428 357)"
                            fill="#DDDEE1"
                        />
                        <rect
                            width="2"
                            height="611"
                            transform="translate(256 264)"
                            fill="#7D818A"
                        />
                        <path
                            d="M257 271.5L252.67 264L261.33 264L257 271.5Z"
                            fill="#7D818A"
                        />
                    </g>
                    <rect
                        x="99.5"
                        y="215.5"
                        width="1101"
                        height="661"
                        rx="8.5"
                        stroke="#0B1228"
                        strokeOpacity="0.14"
                    />
                </g>
                <path
                    d="M66 100C66 92.268 72.268 86 80 86H570V90H80C74.4772 90 70 94.4772 70 100H66ZM570 640H68H570ZM66 640V100C66 92.268 72.268 86 80 86V90C74.4772 90 70 94.4772 70 100V640H66ZM570 88V640V88Z"
                    fill="#0B1228"
                    fillOpacity="0.14"
                    mask="url(#path-11-inside-1_3262_221211)"
                />
                <g clipPath="url(#clip6_3262_221211)">
                    <path
                        d="M514.468 2.80685C514.24 1.88319 513.994 1.08009 513.732 0.406543C513.453 -0.25825 513.155 -0.802484 512.873 -1.22132C512.3 -2.05462 511.744 -2.39577 511.3 -2.27959C510.856 -2.16342 510.506 -1.60351 510.358 -0.630063C510.281 -0.147835 510.261 0.45126 510.286 1.14026C510.292 1.83801 510.355 2.63027 510.489 3.52166C511.152 8.60464 511.438 13.8492 510.818 19.3572C510.499 22.1045 509.942 24.9119 509.01 27.7243C508.566 29.1419 507.97 30.5222 507.321 31.9288C506.622 33.3036 505.879 34.7002 504.948 36.0324C502.904 39.0972 500.802 41.267 498.835 42.9596C496.867 44.6523 495.047 45.8947 493.261 46.9318C491.484 47.9645 489.74 48.7918 487.814 49.5188C485.884 50.2368 483.766 50.8456 481.199 51.2843C476.862 52.0625 471.605 52.2543 466.309 51.4081C461.032 50.5755 455.657 48.6998 451.689 45.7384C449.714 44.2645 448.126 42.5576 447.116 40.7806C446.071 38.954 445.698 37.2999 445.913 35.9828C446.106 34.6654 446.756 33.6256 447.506 32.8819C448.265 32.1339 449.061 31.6904 449.65 31.4371C450.346 31.1312 451.073 30.9106 451.812 30.7841C453.089 30.5736 455.729 30.4443 457.687 33.1837C457.828 33.3372 457.92 33.5483 458.034 33.7374L458.21 34.0299L458.398 34.4165C458.652 34.9379 458.942 35.4641 459.182 36.0256C459.672 37.1443 460.125 38.3476 460.491 39.626C461.225 42.1828 461.661 45.0407 461.571 48.0989C461.446 54.2113 459.149 60.9588 455.399 67.1904C451.659 73.44 446.635 79.2246 441.288 84.2322C433.777 91.3732 426.843 96.2974 421.273 99.9788C415.685 103.647 411.371 106.049 408.398 107.641C401.373 111.42 395.037 114.351 389.082 116.763C383.122 119.166 377.539 121.085 371.898 122.498C368.809 123.258 367.314 124.208 367.404 125.032C367.49 125.825 369.25 126.491 372.568 126.043C378.588 125.201 384.556 123.684 390.849 121.508C397.137 119.323 403.777 116.467 411.04 112.584C413.859 111.065 418.274 108.848 423.859 105.493C429.426 102.125 436.186 97.6191 443.335 91.2884C445.655 89.2237 447.852 86.9968 449.884 84.6608C454.265 79.6119 458.614 73.8113 461.859 67.4583C465.153 61.1593 467.135 54.1984 467.253 47.9114C467.313 44.768 466.945 41.8437 466.336 39.2927C465.745 36.7329 464.877 34.5861 464.104 32.8384C463.683 31.9754 463.36 31.2207 462.889 30.46C462.696 30.0868 462.44 29.7666 462.229 29.4692C462.026 29.1675 461.81 28.9059 461.597 28.6756C461.204 28.2109 460.863 27.8764 460.615 27.6637C460.376 27.4465 460.252 27.329 460.252 27.329C460.252 27.329 460.061 27.166 459.67 26.8891C459.293 26.5946 458.693 26.2082 457.875 25.8062C456.255 25.0158 453.588 24.2906 450.496 24.8625C448.963 25.1419 447.343 25.72 445.79 26.6879C444.237 27.6335 442.765 29.0405 441.659 30.8583C441.131 31.7831 440.696 32.8073 440.429 33.9047C440.185 35.0024 440.062 36.1639 440.166 37.3144C440.321 39.6417 441.242 41.7845 442.359 43.6431C444.677 47.4417 448.298 50.2161 452.088 52.1962C455.909 54.1721 460.003 55.3816 463.994 56.0846C471.989 57.4954 479.546 56.7504 484.962 55.4466C493.149 53.4603 498.676 50.0557 502.397 47.0305C506.123 43.9472 508.168 41.249 509.589 39.1661C510.675 37.5807 511.55 35.9305 512.35 34.3063C513.091 32.6547 513.752 31.0201 514.23 29.3748C515.23 26.1068 515.755 22.8921 515.97 19.8173C516.382 13.6542 515.662 8.04289 514.464 2.7755L514.468 2.80685Z"
                        fill="#101214"
                    />
                    <path
                        d="M375.622 114.366C375.774 113.58 373.093 111.571 372.383 111.94C371.38 112.462 370.518 113.159 369.675 114.26C368.861 115.624 369.193 116.352 368.496 117.182C367.965 117.941 367.066 118.813 366.215 119.739C366.107 119.858 366.003 119.964 365.903 120.08C365.771 120.266 365.644 120.439 365.522 120.621C365.254 120.963 365.045 121.332 364.853 121.692C364.644 122.039 364.502 122.364 364.396 122.649C364.277 122.93 364.181 123.166 364.152 123.335C364.105 123.536 364.081 123.737 364.079 123.938C364.116 124.288 364.185 124.955 364.525 125.745C364.866 126.536 365.514 127.41 366.491 128.091C366.975 128.445 367.563 128.715 368.155 128.994C368.458 129.113 368.774 129.237 369.09 129.361L369.723 129.565C370.539 129.824 371.306 130.051 372.023 130.313C374.088 130.853 375.302 131.129 375.949 131.293C377.466 131.644 378.669 131.602 379.934 131.276C380.624 131.095 381.378 128.281 380.846 127.783C379.89 126.87 378.823 126.255 377.302 125.85C376.718 125.701 375.655 124.617 374.024 124.054C373.766 123.958 373.471 123.946 373.184 123.997C372.566 124.098 371.877 124.099 371.372 124.045L371.171 124.021C371.171 124.021 371.122 124.033 371.1 124.033C371.059 124.042 371.005 124.046 370.961 124.045C370.871 124.044 370.782 124.021 370.702 123.993C370.363 123.869 370.393 123.565 370.402 123.583C370.389 123.579 370.36 123.27 370.602 122.874C370.615 122.834 370.838 122.47 370.993 122.194C371.184 121.901 371.366 121.612 371.557 121.319C371.943 120.741 372.329 120.209 372.61 119.804C373.495 118.584 373.917 117.989 374.184 117.625C374.979 116.515 375.418 115.5 375.622 114.388L375.622 114.366Z"
                        fill="#101214"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_3262_221211">
                    <rect width="570" height="640" fill="white" />
                </clipPath>
                <clipPath id="clip1_3262_221211">
                    <rect
                        width="882.133"
                        height="911.409"
                        fill="white"
                        transform="translate(840.056 -20.8359) rotate(104.62)"
                    />
                </clipPath>
                <clipPath id="clip2_3262_221211">
                    <path
                        d="M68 100C68 93.3726 73.3726 88 80 88H570V640H68V100Z"
                        fill="white"
                    />
                </clipPath>
                <clipPath id="clip3_3262_221211">
                    <rect
                        x="100"
                        y="112"
                        width="32"
                        height="32"
                        rx="4"
                        fill="white"
                    />
                </clipPath>
                <clipPath id="clip4_3262_221211">
                    <rect
                        width="32"
                        height="32"
                        fill="white"
                        transform="translate(100 112)"
                    />
                </clipPath>
                <clipPath id="clip5_3262_221211">
                    <rect
                        x="100"
                        y="216"
                        width="1100"
                        height="660"
                        rx="8"
                        fill="white"
                    />
                </clipPath>
                <clipPath id="clip6_3262_221211">
                    <rect
                        width="189.74"
                        height="65.23"
                        fill="white"
                        transform="translate(540.237 53.1904) rotate(154.026)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
